import React, { useState, useEffect } from "react";
import * as api from "../api/api";
import { BsPersonFillGear } from "react-icons/bs";
import { BiSearch } from "react-icons/bi";
import InputGroup from "react-bootstrap/InputGroup";
import {
  BrowserRouter as Router,
  useNavigate,
  useLocation,
  Outlet,
  useParams,
} from "react-router-dom";
import Loading from "../Components/Loading";
import Form from "react-bootstrap/Form";
import RenderFormList from "../Components/RenderFormList";

import RenderNestedServicesWithForms from "../Components/RenderNestedServicesWithForms";
import { jwtDecode } from "jwt-decode";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

function AdminFormsAndFields(props) {
  const { language } = useLanguage();
  const pageTitle = "AdminFormsAndFields";
  const location = useLocation();
  let services;
  let mappedForms = [];
  const [noneFound, setNoneFound] = useState(false);

  useEffect(() => {
    // filter the forms that are in the services and the ones that arent

    checkAuthorization("FORMS_AND_FIELDS").then((result) => {
      if (result) {
        handleFetchServices();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);
  const [InactiveForms, setInactiveForms] = useState([]);
  const [FilteredInactiveForms, setFilteredInactiveForms] = useState([]);
  const [formsResponse, setFormsResponse] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [noActivationsForms, setNoActivationsForms] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState({});

  const navigate = useNavigate();
  const params = useParams();

  function handleSearch(searchQuery) {
    setSearchQuery(searchQuery);
  }

  const handleFetchServices = () => {
    console.log("called from another place");
    setLoading(true);

    api
      .getAllServices()
      .then((response) => {
        setFormsResponse(response.data.object);
        api
          .getAllUnassignedForms()
          .then((response) => {
            console.log(response);
            let forms = response.data.object;
            setInactiveForms(forms);
            setLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="main-content-container">
      <div className="options-bar">
        <h6 className="options-bar__title">
          {strings[pageTitle][language].pageName}
        </h6>
        <Form.Check // prettier-ignore
          // type={type}
          // id={`default-${type}`}
          size={"sm"}
          style={{
            marginBottom: "1em",
            display: "flex",
            alignItems: "center",
            gap: "1em",
          }}
          label={strings[pageTitle][language].inactive}
          onClick={(e) => {
            // call some function that filters
            console.log(e.target.checked);
            setIsFiltered(e.target.checked);
          }}
        />
        <InputGroup className="mb-3">
          <Form.Control
            placeholder={strings[pageTitle][language].search}
            aria-label="Search"
            aria-describedby="basic-addon2"
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text id="basic-addon2">
            <BiSearch />
          </InputGroup.Text>
        </InputGroup>
        <button
          className="button-options-bar"
          onClick={() => {
            navigate("/formsandfields/createform");
          }}
        >
          {strings[pageTitle][language].addNew}
        </button>

        {isLoading ? (
          <Loading />
        ) : formsResponse.filter((form) =>
            form.name.toLowerCase().includes(searchQuery.toLowerCase())
          ).length == 0 &&
          InactiveForms.filter((form) => {
            const nameMatches = form.name
              .toLowerCase()
              .includes(searchQuery.toLowerCase());
            console.log(nameMatches);
            // If isFiltered is false, count only enabled forms
            // If isFiltered is true, count all forms (enabled and disabled)
            return isFiltered ? nameMatches : !form.isDisabled && nameMatches;
          }).length == 0 ? (
          <p>No results found</p>
        ) : (
          <div className="options-bar__list" id="admin-options-bar">
            <RenderNestedServicesWithForms
              options={
                searchQuery
                  ? formsResponse.filter((form) =>
                      form.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                  : formsResponse
              }
              icon={<BsPersonFillGear size={20} />}
              showInactive={isFiltered}
            />
            <RenderFormList
              forms={
                searchQuery
                  ? InactiveForms.filter((form) =>
                      form.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                  : InactiveForms
              }
              showInactive={isFiltered}
            />
          </div>
        )}
      </div>

      <Outlet
        context={{
          handleFetchServices,
          formsResponse,
          setFormsResponse,
          InactiveForms,
          setInactiveForms,
        }}
      />
    </div>
  );
}

export default AdminFormsAndFields;
